import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import {
  ActionIconContainer,
  RedButton,
} from "../../../shared/components/TableElements";

const CancelAddonModal = ({
  show,
  onHide,
  title,
  addonName,
  periodEndDate,
  addonCost,
  totalAfterCancellation,
  inputDuration,
  onConfirm,
  loading,
  error,
}) => {
  const { t } = useTranslation("common");

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header>
        {/* <Modal.Title style={{ fontSize: 16, fontWeight: 600 }}>
          {title}
        </Modal.Title> */}
        <h4>{title}</h4>
        <div className="d-flex justify-content-end">
          <ActionIconContainer onClick={onHide}>
            <i className="fi fi-rr-cross-small" />
          </ActionIconContainer>
        </div>
      </Modal.Header>
      <Modal.Body>
        <WarningBox>
          {t("cancel_addon_warning", { addonName })}{" "}
          <strong>{periodEndDate}</strong>.
        </WarningBox>

        <InfoRow>
          <RowLabel>{t("current_addon_cost")}</RowLabel>
          <RowValue>{addonCost}</RowValue>
        </InfoRow>

        <RowDivider />

        <InfoRow>
          <div>
            <RowLabel style={{ fontWeight: 600 }}>
              {inputDuration === 2 ? t("yearly_total_after_cancellation") : t("monthly_total_after_cancellation")}
            </RowLabel>
            {periodEndDate && (
              <RowSub>
                {t("effective_date_label", { date: periodEndDate })}
              </RowSub>
            )}
          </div>
          <RowValue style={{ fontWeight: 700 }}>
            {totalAfterCancellation}
          </RowValue>
        </InfoRow>

        {error && <ErrorText>{error}</ErrorText>}
      </Modal.Body>
      <ModalFooter>
        <RedButton type="button" onClick={onConfirm} disabled={loading}>
          {loading ? t("removing") : t("cancel_addon")}
        </RedButton>
      </ModalFooter>
    </Modal>
  );
};

export default CancelAddonModal;

// ── Styled components ──────────────────────────────────────────────────────

const WarningBox = styled.div`
  background: #fef9c3;
  border: 1px solid #fde68a;
  border-radius: 6px;
  padding: 12px 16px;
  font-size: 13.5px;
  color: #78350f;
  line-height: 1.5;
  margin-bottom: 20px;
`;

const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
`;

const RowLabel = styled.span`
  font-size: 14px;
  //color: #6b7280;
`;

const RowValue = styled.span`
  font-size: 14px;
`;

const RowSub = styled.div`
  font-size: 12px;
  color: #9ca3af;
  margin-top: 2px;
`;

const RowDivider = styled.hr`
  margin: 0;
  border-color: #e5e7eb;
`;

const ModalFooter = styled(Modal.Footer)`
  border-top: none;
  justify-content: flex-end;
`;

const DangerBtn = styled.button`
  padding: 8px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  border: none;
  background: #ef4444;
  color: #ffffff;
  cursor: pointer;
  font-family: inherit;
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const ErrorText = styled.div`
  font-size: 13px;
  color: #ef4444;
  margin-top: 8px;
`;
